import Header from "./header";
import Footer from "./footer";

interface Props {
    showFooter?: boolean;
    children: React.ReactNode;
}

export function Layout({ showFooter = true, children }: Props) {
    return (
        <div
            className="h-screen"
            style={{
                backgroundImage: "url('/images/web-background.jpg')",
                backgroundSize: "cover",
            }}
        >
            <Header />
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 col-md-8 offset-md-2">
                        <div className="p-4 border rounded bg-white-transparent">
                            {children}

                            <div className="mt-2" />
                            {showFooter && <Footer />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
